import Mustache from 'mustache/mustache';

class IAutocomplete {
    constructor(el, input, template, hiddenField) {
        // @todo Das Fehlerhandling muss noch implementiert werden.
        this.el = el;
        this.input = input;
        this.template = template;
        this.hiddenField = hiddenField;

        this.val = this.input.val();
        this.bindEvents();
        this.action = this.input.data('action');
    }

    // Input-Interactions
    handleInputChanged() {
        const input = this.input.val();
        if (this.val !== input && input !== '') {
            this.clearSavedGeoId();
            this.request(input, true);
        } else {
            this.close();
        }
        this.val = input;
    }

    handleArrowKeys(keyCode) {
        let el;
        if (keyCode === 38) {
            // Arrow-Up
            if (this.el.css('display') === 'block') {
                el = this.el.find('.autocomplete__item.active');
                if (el.html() === this.el.find('.autocomplete__item').first().html()) {
                    this.closeAndSet();
                }
                el.removeClass('active');
                el.prevAll('.autocomplete__item').first().addClass('active');
            }
        } else if (this.el.css('display') === 'none') {
            // Wenn das Fenster noch nicht angezeigt wird. Befülle es und zeige es an.
            this.request(this.input.val(), true);
        } else if (this.el.find('.autocomplete__item.active').length === 0) {
            // Wenn es schon angezeigt wird navigiere dadurch.
            this.el.find('.autocomplete__item').first().addClass('active');
        } else {
            el = this.el.find('.autocomplete__item.active');
            el.removeClass('active');
            el.nextAll('.autocomplete__item').first().addClass('active');
        }
    }

    clearSavedGeoId() {
        this.hiddenField.val('');
    }

    setGeocodeValue(objectClicked) {
        this.input.val(objectClicked.text());
        this.hiddenField.val(objectClicked.data('id'));
        this.close();
        this.input.trigger('autocomplete-geocode-set');
    }

    // Autocomplete Select-Box
    close() {
        this.el.hide();
    }

    closeAndSet() {
        const item = this.el.find('.autocomplete__item');
        if (item) {
            this.setGeocodeValue(item.first());
        }
        this.el.hide();
    }

    open() {
        this.el.show();
    }

    isOpen() {
        return this.el.css('display') !== 'none';
    }

    update(msg) {
        const customTags = ['%', '%'];
        Mustache.parse(this.template, customTags);
        const rendered = Mustache.render(this.template, msg);
        $('#target-filter').html(rendered);

        this.bindEventsForResults();
    }

    // Ajax-Requests
    request(val, open) {
        $.ajax({
            url: this.action,
            type: 'POST',
            data: {
                string: val,
            },
            success: (msg) => {
                this.handleResponse(msg, open);
            },
        });
    }

    handleResponse(response, open) {
        if ($.isEmptyObject(response)) {
            this.close();
        } else {
            this.update(response);
            if (open === true) {
                this.open();
            } else {
                this.closeAndSet();
            }
        }
    }

    handleKeys(e) {
        if (e.keyCode === 38 || e.keyCode === 40) {
            this.handleArrowKeys(e.keyCode, e);
        } else if (e.keyCode === 9 || e.keyCode === 13) {
            if (this.el.css('display') === 'block') {
                e.preventDefault();
            }
            if (this.el.find('.autocomplete__item.active').length > 0) {
                this.setGeocodeValue(this.el.find('.autocomplete__item.active'));
            } else {
                this.request(this.input.val(), false);
            }
        } else {
            this.handleInputChanged();
        }
    }

    // Bind Events
    bindEvents() {
        this.input.on('keyup', e => this.handleKeys(e));

        $(document).on('click', (e) => {
            if ($('.I_OBJ_searchbox__city-wrapper').has(e.target).length === 0 && this.el.css('display') === 'block') {
                if (this.el.find('.autocomplete__item.active').length !== 0) {
                    this.setGeocodeValue(this.el.find('.autocomplete__item.active'));
                } else {
                    this.setGeocodeValue(this.el.find('.autocomplete__item').first());
                }
            }
        });
    }

    bindEventsForResults() {
        this.el.find('.autocomplete__item').on('mousedown', (e) => {
            this.setGeocodeValue($(e.currentTarget));
        });
    }
}

const iFilterAutocompleteExport = {
    initAutocomplete() {
        const el = $('.I-js-FM-1-autocomplete-city-filter');
        const inputCity = $('.I-js-FM-1-autocomplete-city-input-filter');
        const template = $('#template-filter').html();
        const hiddenField = $('.I-js-FM-1-autocomplete-geoid');

        if (el.length) {
            // eslint-disable-next-line no-new
            new IAutocomplete(el, inputCity, template, hiddenField);
        }
    },
    init() {
        this.initAutocomplete();

        $(window).on('init-city-filter-autocomplete', () => {
            this.initAutocomplete();
        });
    },
};

export default iFilterAutocompleteExport;
